import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';

const EndLayout = styled.div`
  width: 100vw;
  min-height: 100vh;
  min-width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
  box-sizing: border-box;

  /* 1) 검정 반투명 오버레이 (맨 위)
    2) BG 이미지 (중간)
    3) 보라색 그라데이션 (맨 아래) */
  background:
  /* overlay as a gradient image */
  linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)),
  /* actual BG image, vertical fit */
  url('/BG.jpeg') center top / auto 100vh no-repeat fixed,
  /* purple gradient fill */
  linear-gradient(150deg, #d3e067 0%, #d3e067 100%);
  
  /* 오버레이만 multiply, 나머지는 normal */
  background-blend-mode: multiply, normal, normal;
`;

const Banner = styled.div`
  width: 90%;
  max-width: 400px;
  height: 80px;
  margin: 0 auto;
  margin-top: calc(var(--vh, 1vh) * 2);
  margin-bottom: calc(var(--vh, 1vh) * 2);
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  border-radius: 0;
  box-shadow: none;

  @media (max-width: 768px) {
    width: 80%;
    max-width: 300px;
    height: 60px;
    margin-top: calc(var(--vh, 1vh) * 1);
    margin-bottom: calc(var(--vh, 1vh) * 1);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 0;
    box-shadow: none;
  }
`;

const MainContent = styled.div`
  flex: 1 1 0;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 0 24px 0;
  max-width: 700px;
  margin: 0 auto;
  position: relative;
  height: calc(var(--vh, 1vh) * 100 - 100px);

  @media (max-width: 768px) {
    max-width: 90vw;
  }
`;

const Title = styled.h1`
  font-size: 2.2rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 18px;
  text-align: center;
  text-shadow: 2px 2px 8px rgba(80, 40, 120, 0.18);
`;

const Subtitle = styled.p`
  font-size: 1.15rem;
  color: #f3eaff;
  margin-bottom: 30px;
  text-align: center;
`;

const VideoWrapper = styled.div`
  width: 100%;
  max-width: 420px;
  aspect-ratio: 16/9;
  margin-bottom: 28px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(80, 40, 120, 0.18);
  background: #000;

  @media (max-width: 768px) {
    max-width: 95vw;
    border-radius: 10px;
  }
`;

const InfoText = styled.div`
  text-align: center;
  color: #f3eaff;
  font-size: 1.2rem;
  line-height: 1.5;
  margin-top: 10px;



  @media (max-width: 768px) {
      font-size: 1rem;

      h1 {
        font-size: 1.8rem;
      }
  }
`;

const DateText = styled.p`
  font-size: 1rem;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

const BottomSpacer = styled.div`
  width: 100%;
  height: 100px;
  @media (max-width: 768px) {
    height: 100px;
  }
`;

const EventEnd = ({ videoUrl = 'https://youtube.com/shorts/zBzp5GyihW4?feature=share' }) => {

  // YouTube embed URL 생성
  const getEmbedUrl = () => {
    try {
      const urlObj = new URL(videoUrl);
      let videoId = urlObj.searchParams.get('v');
      if (!videoId) {
        const paths = urlObj.pathname.split('/');
        videoId = paths[paths.length - 1];
      }
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1&modestbranding=1&rel=0&showinfo=0&playsinline=1&loop=1&playlist=${videoId}`;
    } catch {
      return videoUrl;
    }
  };

  return (
    <EndLayout>
      {/* <Banner>
        <img src="/PURPLEKISS_Logo.png" alt="PURPLE K!SS" />
      </Banner> */}
      <MainContent>
        <img 
          src="/I Miss My.png" 
          alt="I Miss My" 
          style={{
            width: '300px',
            height: 'auto',
            objectFit: 'contain',
            //cursor: 'pointer' // 클릭 가능함을 표시
          }}
          // onTouchStart={handleTitleClick}
          // onMouseDown={handleLongPressStart}
          // onMouseUp={handleLongPressEnd}
          // onTouchStart={handleLongPressStart}
          // onTouchEnd={handleLongPressEnd}
          // onMouseLeave={handleLongPressEnd}
        />
        {/* <Title>7월18일 오후 6시!</Title> */}
        {/* <Subtitle>곧 새로운 리듬게임이 여러분을 찾아갑니다!</Subtitle> */}
        {/* <VideoWrapper>
          <iframe
            width="100%"
            height="100%"
            src={getEmbedUrl()}
            title="Coming Soon Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ display: 'block', width: '100%', height: '100%' }}
          />
        </VideoWrapper> */}
        <InfoText>
          <h1><strong>이벤트가 종료되었습니다!</strong></h1>
          <p>많은 참여와 관심에 진심으로 <strong>감사드립니다</strong> 💛</p>
          < br/>
          <DateText><strong>당첨자는 2025년 8월 3일(일) (KST)</strong>부터 개별 안내 예정입니다</DateText>
          <DateText style={{wordBreak: 'keep-all'}}><strong>리워드는 2025년 8월 4일(월) (KST)</strong>부터 순차적으로 발송할 예정입니다</DateText>
        </InfoText>
      </MainContent>
      <BottomSpacer />
    </EndLayout>
  );
};

export default EventEnd; 